<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-UploadInformationModel-Title" slot="header">{{ $t('informationModelUploadDialogTitle') }}</span>
    <el-form ref="data" :model="data" id="uploadform" @submit.native.prevent="save" enctype="multipart/form-data" label-position="left">
      <el-form-item
        :data-qa="`Dialog-UploadInformationModelUpload-${key}`"
        :key="key"
        :label-width="labelWidth"
        :label="field.label"
        v-for="(field, key) in fieldsData"
      >
        <div class="upload-block">
          <input
            @change="filesChange(key, $event.target.name, $event.target.files)"
            :id="field.name"
            :name="field.name"
            accept=".json,.yaml,.yml"
            class="input-file"
            :data-qa="`Dialog-UploadInformationModelUpload${key}-UploadField`"
            multiple
            type="file"
            v-bind="field.model"
            v-validate="field.validate"
          >
          <label :for="field.name" class="el-button el-button--default">{{ $t('informationModelUploadButtonUploadText') }}</label>
          <div class="selected-file-name">{{ field.selectedFileName }}</div>
        </div>
        <div class="help is-danger" v-if="errors.has(field.name)">
          {{ $t('informationModelUploadInputUploadError') }}
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer-content">
      <el-alert
        :closable="false"
        :type="alert$.type"
        data-qa="Dialog-UploadInformationModel-Alert"
        show-icon
        title=""
        v-show="alert$.show"
      >
        <p :key="index" v-for="(error, index) in alert$.errors">
          {{ error }}
        </p>
      </el-alert>
    </span>
    <span slot="actions">
      <el-button
        @click="closePopup"
        class="btn-close"
        data-qa="Dialog-UploadInformationModel-Button-Close"
        type="text"
      >
        {{ $t('informationModelUploadDialogButtonCloseText') }}
      </el-button>
      <el-button
        :disabled="loading || errors.any()"
        :loading="loading"
        @click="save"
        data-qa="Dialog-UploadInformationModel-Button-Upload"
        type="warning"
      >
        {{ $t('informationModelUploadDialogButtonUploadText') }}
      </el-button>
    </span>
  </hamv-dialog>
</template>

<script>
  import main from './InformationModelUpload.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './InformationModelUpload.scss'
</style>



// WEBPACK FOOTER //
// InformationModelUpload.vue?a08db3da